import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";

// Floating WhatsApp click-to-chat button for public pages.
export const WhatsAppFab = ({ text = "Hi! I'd like help with iYeneh Connect." }) => (
  <a
    href={`https://wa.me/12029403399?text=${encodeURIComponent(text)}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 font-semibold text-white shadow-xl transition-transform hover:scale-105"
  >
    <WhatsappLogo size={22} weight="fill" />
    <span className="hidden sm:inline">Chat with us</span>
  </a>
);
